export default __webpack_public_path__ + "static/media/bse-1000-index-fund-connector-desktop.528c4a4b.webp";